import {useOutletContext} from "react-router-dom";

import {useErrors} from "base/error/provider";
import {PermitApplicationService} from "permitapplication/service";
import {permit_view_adapter} from "permit/model";
import {useNavigateWithReload} from "base/navigation/hooks";

import {PermitApplicationTechnicalDataTabs} from ".";
import {FormContainer} from "base/form/components";

const PermitApplicationTechnicalDataStep = () => {
    const {permit, isStepEditable} = useOutletContext();
    const {handleErrors} = useErrors();
    const navigate = useNavigateWithReload();

    const handlePermitApplicationFormSubmit = updatedPermit => {
        PermitApplicationService.update(permit_view_adapter(updatedPermit))
            .then(updatedPermit => {
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return (
        <FormContainer>
            <PermitApplicationTechnicalDataTabs
                permit={permit}
                onSubmitPermitApplication={handlePermitApplicationFormSubmit}
                isStepEditable={isStepEditable}
            />
        </FormContainer>
    );
};

export default PermitApplicationTechnicalDataStep;
